<div class="container mt-3 px-2">
  <div class="row">
    <div class="col-md-9 w-100 mt-3">
      <h4 class="title"><i class="fas fa-file-contract"></i> {{title | translate}}</h4>
    </div>
    <div class="col-md-3 mt-3 div-right" *ngIf="hasAuthority('own:view:document:10201')">
      <div ngbDropdown class="custom-button" style="z-index: 100!important; opacity: 1!important;">
        <button class="btn btn-outline-success custom-button btn-float font-weight-bold" id="dropdownForm1"
                ngbDropdownToggle>
          <i class="fa fa-plus" aria-hidden="true"></i> {{ "BUTTON.MORE-ACTIONS" | translate }}
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownForm1" class="dropdown_menu-8">
          <a ngbDropdownItem class="cursor-hover"
             *ngIf="!isInvitedUser && hasAuthority('own:document:add:one2one') && hasWorkflowsBy(SIGNTYPE_ONE2ONE)"
             (click)="loadRequiredDataAndOpenModalAddOne()">
            <i class="fa fa-file-pdf"></i> {{ "BUTTON.ADD-DOCUMENT" | translate }}
          </a>
          <a ngbDropdownItem class="cursor-hover"
             *ngIf="!isInvitedUser && hasAuthority('own:document:add:batch') && hasWorkflowsBy(SIGNTYPE_BATCH)"
             (click)="loadRequiredDataAndOpenModalAddBatch()">
            <i class="fa fa-file-archive"></i> {{ "BUTTON.ADD-DOCUMENT-IN-BATCHES" | translate }}
          </a>
          <a ngbDropdownItem class="cursor-hover"
             *ngIf="!isInvitedUser && hasAuthority('own:document:add:batch') && hasWorkflows4Notif()"
             (click)="loadRequiredDataAndOpenModalAddNotifyBatch()">
            <i class="fa fa-file-archive"></i> {{ "BUTTON.ADD-DOCUMENT-NOTIFY-IN-BATCHES" | translate }}
          </a>
          <a ngbDropdownItem class="cursor-hover"
             *ngIf="!isInvitedUser && hasAuthority('own:document:add:one2one:dynamic') && hasWorkflowsBy(SIGNTYPE_DYNAMIC)"
             (click)="loadRequiredDataAndOpenModalAddDynamic()">
            <i class="fa fa-file-signature"></i> {{ "BUTTON.ADD-DOCUMENT-FOR-SIGNATURE-DYNAMIC" | translate }}
          </a>
          <a ngbDropdownItem class="{{!isEmptySelectedListDigitalSignatures?'disabled':''}} cursor-hover"
             *ngIf="hasAuthority('own:document:sign:batch') && isOperationTypeDigitalSignatures"
             (click)="signDigitallyBatch(false)">
            <i class="fa fa-signature"></i> {{ "BUTTON.DIGITAL-SIGNATURE-IN-BATCH" | translate }}
          </a>
          <a ngbDropdownItem class="{{!isEmptySelectedListDigitalSignaturesWithDragRubric?'disabled':''}} cursor-hover"
             *ngIf="hasAuthority('own:document:sign:batch') &&  isOperationTypeDigitalSignatures"
             (click)="signDigitallyBatch(true)">
            <i class="fa fa-signature"></i> {{ "BUTTON.DIGITAL-SIGNATURE-IN-BATCH-WITH-DRAG-AND-DROP" | translate }}
          </a>
          <a ngbDropdownItem class="{{!isEmptySelectedListElectronicSignatures?'disabled':''}} cursor-hover"
             *ngIf="hasAuthority('own:document:sign:10205') && isOperationTypeDigitalSignatures"
             (click)="signElectronicallyBatch()">
            <i class="fa fa-stamp"></i> {{ "BUTTON.GRAPHIC-SIGNATURE-IN-BATCH" | translate }}
          </a>
          <a ngbDropdownItem class="{{!isEmptySelectedListNotify?'disabled':''}} cursor-hover"
             *ngIf="hasAuthority('own:document:sign:10205')"
             (click)="notifyInBatch()">
            <i class="fas fa-mail-bulk"></i> {{ "BUTTON.NOTIFY-IN-BATCH" | translate }}
          </a>
          <a ngbDropdownItem class="{{!isEmptySelectedListCloudSignatures?'disabled':''}} cursor-hover"
             *ngIf="hasAuthority('own:document:sign:10201') && isOperationTypeDigitalSignatures"
             (click)="signInCloudBatch()">
            <i class="fa fa-stamp"></i> {{ "BUTTON.ONE-SIGN-SIGNATURE-IN-BATCH" | translate }}
          </a>
          <a ngbDropdownItem class="{{!isEmptySelectedListRemoteSignatures?'disabled':''}} cursor-hover"
             *ngIf="hasAuthority('own:document:sign:10203') && isOperationTypeDigitalSignatures"
             (click)="signRemoteBatch()">
            <i class="fa fa-stamp"></i> {{ "BUTTON.REMOTE-SIGNATURE-IN-BATCH" | translate }}
          </a>
          <a ngbDropdownItem class="{{!isEmptySelectedListReview?'disabled':''}} cursor-hover"
             *ngIf="hasAuthority('own:document:review:batch')"
             (click)="reviewBatch()">
            <i class="far fa-eye"></i> {{ "BUTTON.REVIEW-IN-BATCH" | translate }}
          </a>
          <a ngbDropdownItem class="{{!isEmptySelectedListFinishedDocument?'disabled':''}} cursor-hover"
             *ngIf="hasAuthority('own:document:attend:batch')"
             (click)="openModalAttend()">
            <i class="fa fa-arrow-circle-right"></i> {{ "BUTTON.MARK-AS-ATTENDED-IN-BATCH" | translate }}
          </a>
          <a ngbDropdownItem class="{{!isEmptySelectedListAttendedDocument?'disabled':''}} cursor-hover"
             *ngIf="hasAuthority('own:document:unattend:batch')"
             (click)="openModalUnattend()">
            <i class="fa fa-arrow-circle-left"></i> {{ "BUTTON.MARK-AS-UNATTENDED-IN-BATCH" | translate }}
          </a>
          <a ngbDropdownItem class="{{!isEmptySelectedListFinishedDocument?'disabled':''}} cursor-hover"
             *ngIf="hasAuthority('own:resource:get:batch:stream')"
             (click)="downloadMultipleDocuments()">
            <i class="fa fa-file-download"></i> {{ "BUTTON.DOWNLOAD-SIGNED-DOCUMENTS" | translate }}
          </a>
          <a ngbDropdownItem class="cursor-hover"
             *ngIf="(hasDeleteOptionInBatch || (hasAuthority('own:document:delete:batch') && isAllowedDeleteInBatch))
              || hasAuthority('own:view:document:10209')"
             (click)="openModalDeleteBatch()">
            <i class="fa fa-trash"></i> {{ "BUTTON.DELETE-PENDING-DOCUMENTS-IN-BATCH" | translate }}
          </a>
        </div>
      </div>
    </div>
    <div class="col-md-3 mt-3 div-right">
      <button class="btn btn-outline-success btn-width-100 btn-float btn1 font-weight-bold" id="dropdownForm2"
              *ngIf="!isInvitedUser && hasAuthority('own:view:document:10200') && hasWorkflowsBy(SIGNTYPE_ONE2ONE)"
              (click)="loadRequiredDataAndOpenModalAddOne()">
        <i class="fa fa-signature"></i> {{ "BUTTON.UPLOAD-AND-SIGN" | translate }}
      </button>
    </div>
  </div>
</div>
<div class="bg-white-radius">
  <div class="document-filters">
    <div class="filter-heading">
      <h5><i class="fas fa-sliders-h" aria-hidden="true"></i> {{ 'TITLE.SEARCH-OPTIONS' | translate }}</h5>
    </div>
    <div class="filter-primary">
      <div class="filter-field" *ngIf="hasRole(ROLE_SUPERADMIN)">
        <label for="documentPartner">{{ 'LABEL.PARTNER' | translate }}</label>
        <select id="documentPartner" class="form-control" [(ngModel)]="partnerSelected" (ngModelChange)="onPartnerChange()"
                [ngbTooltip]="'LABEL.FILTER-HELP-PARTNER' | translate">
          <option *ngFor="let partner of partners" [ngValue]="partner">{{partner.name | translate}}</option>
        </select>
      </div>
      <div class="filter-field" *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER)">
        <label for="documentEnterprise">{{ 'LABEL.ENTERPRISE' | translate }}</label>
        <select id="documentEnterprise" class="form-control" [(ngModel)]="enterpriseSelected" (ngModelChange)="reloadDocuments1()"
                [ngbTooltip]="'LABEL.FILTER-HELP-ENTERPRISE' | translate">
          <option *ngFor="let enterprise of enterprises" [ngValue]="enterprise">{{enterprise.name | translate}}</option>
        </select>
      </div>
      <div class="filter-field">
        <label for="documentWorkflow">{{ 'LABEL.FLOW' | translate }}</label>
        <select id="documentWorkflow" class="form-control" [(ngModel)]="workflowSelected" (ngModelChange)="reloadDocuments2()"
                [ngbTooltip]="'LABEL.FILTER-HELP-WORKFLOW' | translate">
          <option *ngFor="let workflow of workflows" [ngValue]="workflow">{{workflow.description | translate}}</option>
        </select>
      </div>
      <div class="filter-field state-filters">
        <div class="state-filter-heading">
          <label id="documentStateLabel">{{ 'LABEL.STATE' | translate }}</label>
          <span id="documentStateLocation" class="state-location-hint">
            <i class="fas fa-info-circle" aria-hidden="true"></i> {{ 'LABEL.FILTER-STATES-LOCATION' | translate }}
          </span>
        </div>
        <div ngbDropdown [autoClose]="'outside'" placement="bottom-right" class="state-picker">
          <button type="button" class="form-control state-picker-button" ngbDropdownToggle
                  aria-labelledby="documentStateLabel" aria-describedby="documentStateLocation" [disabled]="loadingShowBy"
                  [ngbTooltip]="'LABEL.FILTER-HELP-STATES' | translate">
            <span>{{ 'LABEL.FILTER-SELECT-STATES' | translate }}</span>
            <span class="state-picker-count">{{selectedStates.length}}</span>
          </button>
          <div ngbDropdownMenu class="state-menu">
            <label class="state-option" *ngIf="myPendingState?.shortDescription">
              <input type="checkbox" [checked]="wasSelected2(myPendingState)" (change)="addRemoveState($event, myPendingState)" [disabled]="loadingShowBy">
              <span>{{ stateLabel(myPendingState) }}</span>
            </label>
            <label class="state-option" *ngFor="let state of states">
              <input type="checkbox" [checked]="wasSelected2(state)" (change)="addRemoveState($event, state)" [disabled]="loadingShowBy">
              <span>{{ stateLabel(state) }}</span>
            </label>
          </div>
        </div>
      </div>
      <div class="filter-field filter-subject">
        <label for="searchInput">{{ 'LABEL.SUBJECT' | translate }}</label>
        <input type="text" id="searchInput" class="form-control"
               [placeholder]="'MESSAGE.ENTER-TO-SEARCH' | translate"
               [(ngModel)]="subject" (keyup.enter)="search()"
               [ngbTooltip]="'LABEL.FILTER-HELP-SUBJECT' | translate">
      </div>
      <div class="filter-actions">
        <button type="button" class="btn btn-success" [disabled]="invalidDateRange" (click)="search()"
                [ngbTooltip]="'LABEL.FILTER-HELP-SEARCH' | translate">
          <i class="fa fa-search" aria-hidden="true"></i> {{ 'BUTTON.SEARCH' | translate }}
        </button>
        <button type="button" class="btn btn-outline-secondary" (click)="clearFilters()"
                [ngbTooltip]="'LABEL.FILTER-HELP-CLEAR' | translate">
          <i class="fas fa-eraser" aria-hidden="true"></i> {{ 'BUTTON.CLEAR-FILTERS' | translate }}
        </button>
      </div>
    </div>
    <button type="button" class="filter-toggle"
            [attr.aria-expanded]="showAdditionalFilters"
            aria-controls="additional-document-filters"
            (click)="showAdditionalFilters = !showAdditionalFilters"
            [ngbTooltip]="'LABEL.FILTER-HELP-ADVANCED' | translate">
      <i class="fas fa-filter" aria-hidden="true"></i>
      {{ 'LABEL.ADVANCED-SEARCH' | translate }}
      <span class="filter-count" *ngIf="activeAdditionalFilterCount">{{activeAdditionalFilterCount}}</span>
      <i class="fas filter-chevron" [ngClass]="showAdditionalFilters ? 'fa-chevron-up' : 'fa-chevron-down'" aria-hidden="true"></i>
    </button>
    <div id="additional-document-filters" class="additional-filters" *ngIf="showAdditionalFilters">
      <div class="filter-section-title">{{ 'LABEL.FILTER-PARTICIPANT' | translate }}</div>
      <div class="filter-grid filter-grid-participant">
        <div class="filter-field">
          <label for="documentNumber">{{ 'LABEL.IDENTIFICATION-DOCUMENT-NUMBER' | translate }}</label>
          <input id="documentNumber" type="text" class="form-control" [(ngModel)]="searchFilters.documentNumber" (keyup.enter)="search()"
                 [placeholder]="'LABEL.FILTER-PLACEHOLDER-DOCUMENT-NUMBER' | translate"
                 [ngbTooltip]="'LABEL.FILTER-HELP-DOCUMENT-NUMBER' | translate">
        </div>
        <div class="filter-field">
          <label for="documentFullName">{{ 'LABEL.NAMES-PARTICIPANT' | translate }}</label>
          <input id="documentFullName" type="text" class="form-control" [(ngModel)]="searchFilters.fullName" (keyup.enter)="search()"
                 [placeholder]="'LABEL.FILTER-PLACEHOLDER-NAME' | translate"
                 [ngbTooltip]="'LABEL.FILTER-HELP-FULL-NAME' | translate">
        </div>
        <div class="filter-field">
          <label for="documentRuc">{{ 'LABEL.RUC-PARTICIPANT' | translate }}</label>
          <input id="documentRuc" type="text" class="form-control" [(ngModel)]="searchFilters.ruc" (keyup.enter)="search()"
                 [placeholder]="'LABEL.FILTER-PLACEHOLDER-RUC' | translate"
                 [ngbTooltip]="'LABEL.FILTER-HELP-RUC' | translate">
        </div>
        <div class="filter-field">
          <label for="documentBusinessName">{{ 'LABEL.BUSINESS-NAME-PARTICIPANT' | translate }}</label>
          <input id="documentBusinessName" type="text" class="form-control" [(ngModel)]="searchFilters.businessName" (keyup.enter)="search()"
                 [placeholder]="'LABEL.FILTER-PLACEHOLDER-BUSINESS-NAME' | translate"
                 [ngbTooltip]="'LABEL.FILTER-HELP-BUSINESS-NAME' | translate">
        </div>
      </div>
      <div class="filter-section-title">{{ 'LABEL.FILTER-DOCUMENT' | translate }}</div>
      <div class="filter-grid filter-grid-document">
        <div class="filter-field">
          <label for="documentUploader">{{ 'LABEL.FILTER-UPLOADER' | translate }}</label>
          <input id="documentUploader" type="text" class="form-control" [(ngModel)]="searchFilters.uploader" (keyup.enter)="search()"
                 [placeholder]="'LABEL.FILTER-PLACEHOLDER-NAME' | translate"
                 [ngbTooltip]="'LABEL.FILTER-HELP-UPLOADER' | translate">
        </div>
        <div class="filter-field">
          <label for="documentDateFrom">{{ 'LABEL.FROM' | translate }}</label>
          <div class="input-group">
            <input id="documentDateFrom" class="form-control" ngbDatepicker #fromPicker="ngbDatepicker"
                   placeholder="dd/mm/yyyy" [(ngModel)]="searchFilters.dateFrom_"
                   [ngbTooltip]="'LABEL.FILTER-HELP-DATE-FROM' | translate">
            <div class="input-group-append">
              <button type="button" class="btn btn-outline-secondary" (click)="fromPicker.toggle()" [attr.aria-label]="'LABEL.FROM' | translate"
                      [ngbTooltip]="'LABEL.FILTER-HELP-DATE-FROM' | translate">
                <i class="far fa-calendar-alt"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="filter-field">
          <label for="documentDateTo">{{ 'LABEL.TO' | translate }}</label>
          <div class="input-group">
            <input id="documentDateTo" class="form-control" ngbDatepicker #toPicker="ngbDatepicker"
                   placeholder="dd/mm/yyyy" [(ngModel)]="searchFilters.dateTo_"
                   [ngbTooltip]="'LABEL.FILTER-HELP-DATE-TO' | translate">
            <div class="input-group-append">
              <button type="button" class="btn btn-outline-secondary" (click)="toPicker.toggle()" [attr.aria-label]="'LABEL.TO' | translate"
                      [ngbTooltip]="'LABEL.FILTER-HELP-DATE-TO' | translate">
                <i class="far fa-calendar-alt"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <p class="text-danger mt-2 mb-0" role="alert" *ngIf="invalidDateRange">
        {{ 'MESSAGE.DATE-RANGE-INVALID' | translate }}
      </p>
    </div>
    <div class="custom-progressbar-position mt-3"
         *ngIf="hasAuthority('own:view:bar:limit:storage:500') && existLimitStorage">
      <div class="progress">
        <div class="progress-bar progress-bar-striped {{limitStorageSupered ? 'bg-danger': 'bg-success'}}"
             role="progressbar" aria-valuenow="0"
             [ngStyle]="{ width: getProgress() + '%' }" aria-valuemin="0" [attr.aria-valuenow]="limitStorageBytes">
        <span
          class="{{limitStorageSupered ? 'float-message text-white': 'float-message'}}">{{ formatStorageLimit(enterpriseStorage.usedStorageBytes, 2) }}
          {{"LABEL.STORAGE-OF" | translate }} {{ enterpriseStorage.limitStorage + ' ' + getUnitType(enterpriseStorage) }}
          {{"LABEL.STORAGE-USED" | translate }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-2 mb-2 custom-table-height table-responsive">
    <table class="table-sm table-bordered">
      <thead>
      <tr class="bg-dark-light">
        <th scope="col"
            [hidden]="!hasAuthority('own:view:document:10206')" title2="Seleccionar todos:">
          <div class="custom-control custom-checkbox-right custom-checkbox my-1 mr-sm-1">
            <input type="checkbox"
                   class="custom-control-input"
                   id="addRemoveAllCheckbox"
                   [checked]="wasAllSelected()"
                   (click)="addOrRemoveAll($event)">
            <label class="custom-control-label" for="addRemoveAllCheckbox"></label>
          </div>
        </th>
        <th scope="col" title="#"></th>
        <th scope="col" *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER)" title="{{ 'TABLE.HEADER.ENTERPRISE' | translate }}"></th>
        <th scope="col" title="{{'TABLE.HEADER.FLOW' | translate }}"></th>
        <th scope="col" title="{{'TABLE.HEADER.UPLOADER' | translate }}"></th>
        <th scope="col" title="{{'TABLE.HEADER.SUBJECT' | translate }}"></th>
        <th scope="col" title="{{'TABLE.HEADER.DATE' | translate }}"></th>
        <th scope="col" title="{{'TABLE.HEADER.NOTES' | translate }}"></th>
        <th scope="col" title="{{'TABLE.HEADER.PROGRESS' | translate }}"></th>
        <th scope="col" title="{{'TABLE.HEADER.SIGNATORY-REVIEWER' | translate }}"></th>
        <th scope="col" title="{{'TABLE.HEADER.STATE' | translate }}"></th>
        <th scope="col" title="{{'TABLE.HEADER.ACTION' | translate }}"></th>
      </tr>
      </thead>
      <tr *ngIf="emptyResult">
        <td [attr.colspan]="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER) ? 11 : 10" class="custom-height-500">
          {{ "MESSAGE.NO-RECORDS-AVAILABLE" | translate }}
        </td>
      </tr>
      <tbody *ngIf="!emptyResult">
      <tr *ngFor="let document of documents; let index=index" class="custom-font-size-table-body">
        <td title="{{'TABLE.HEADER.SELECTED-RECORD' | translate}} {{(page.number * pageNumber) + index + 1}}"
            [hidden]="!hasAuthority('own:view:document:10206')">
          <div class="custom-control custom-checkbox my-1 mr-sm-2">
            <input type="checkbox"
                   class="custom-control-input"
                   id="addRemoveCheckbox{{index}}"
                   [checked]="wasSelected(document)"
                   (click)="addOrRemove($event, document)">
            <label class="custom-control-label" for="addRemoveCheckbox{{index}}"></label>
          </div>
        </td>
        <td title="#" class="hidden-tag"><b>{{(page.number * pageNumber) + index + 1}}</b></td>
        <td class="mw-180" title="{{'TABLE.HEADER.ENTERPRISE' | translate }}"
            *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER)">{{document._more.enterpriseName}}</td>
        <td title="{{'TABLE.HEADER.FLOW' | translate }}" class="custom-div-words">
          {{document._more.workflowDescription}}</td>
        <td class="mw-234" title="{{'TABLE.HEADER.UPLOADER' | translate }}">
          <i class="fa fa-user-circle icon-color-mediumyellow" aria-hidden="true"></i>
          {{document._more.uploaderName}}
        </td>
        <td title="{{'TABLE.HEADER.SUBJECT' | translate }}" class="custom-div-words">{{document.subject}}</td>
        <td title="{{'TABLE.HEADER.DATE' | translate }}" class="w-td cw-100">{{document.createAt | dateformat}}</td>
        <td title="{{'TABLE.HEADER.NOTES' | translate }}" class="mw-85"><a
          *ngIf="!hasComment(document) && !isOneSignSignature(document)">-</a>
          <span *ngIf="hasComment(document) && hasAuthority('own:document:get:cancel:observation')"
                class="badge {{getBadgeTextBy(document)}}" data-toggle="tooltip" data-placement="bottom"
                title="{{wasCanceled(document) || wasModified(document) ? ('TITLE.REVIEW-THE-REASON' | translate) : ('TITLE.REVIEW-COMMENTS' | translate)}}"
                (click)="viewObservation(document)">{{ 'BUTTON.VIEW' | translate }}</span>
          <span *ngIf="isOneSignSignature(document)"
                class="badge badge-primary">
            {{getTypeSignPerson(document)}}
          </span>
          <span *ngIf="isOneSignSignature(document) && hasRole(ROLE_USER)"
                class="badge badge-dark">
          {{getStatus(document)}}
        </span>
        </td>
        <td title="{{'TABLE.HEADER.PROGRESS' | translate }}" class="w-td">
          <span class="{{getSpanClass(document)}}">
            {{document._more.assignmentProgress | translate}}
          </span>
        </td>
        <td title="{{ 'TITLE.SIGNATORY-REVIEWER' | translate }}" class="w-200">
          {{document._more.fullnameNextSigner}}
        </td>
        <td title="{{'TABLE.HEADER.STATE' | translate }}" class="w-td">
          {{ document.active ? ('TABLE.HEADER.ACTIVE' | translate) : ('TABLE.HEADER.INACTIVE' | translate) }}
        </td>
        <td class="mw-63" title="{{'TABLE.HEADER.ACTION' | translate }}">
          <div class="dropdown">
            <a type="button" class="btn btn-default position-end" id="dropdownMenuButton"
               data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fa fa-ellipsis-v"></i>
            </a>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <a class="dropdown-item cursor-hover pointer"
                 *ngIf="hasUniqueAttachDigitalSignatureOption(document)
                 && hasAuthority('own:document:sign:one2one')
                 && completedReview(document)"
                 (click)="openModalSignDigital(document)">
                <i class="fa fa-signature"></i> {{ "BUTTON.DIGITALLY-SIGN" | translate }}
              </a>
              <a class="dropdown-item cursor-hover pointer"
                 *ngIf="hasElectronicSignatureOption(document) && hasAuthority('own:document:sign:10204')"
                 (click)="openModalSignDocumentInternal(document)">
                <i class="fa fa-stamp"></i> {{ "BUTTON.GRAPHICALLY-SIGN" | translate }}
              </a>
              <a class="dropdown-item cursor-hover pointer"
                 *ngIf="hasNotificationOption(document)"
                 (click)="openModalSignDocumentInternal(document)">
                <i class="fas fa-mail-bulk"></i> {{ "BUTTON.NOTIFY" | translate }}
              </a>
              <a class="dropdown-item cursor-hover pointer"
                 *ngIf="hasNotificationAndSignOption(document)"
                 (click)="openModalSignDocumentInternal(document)">
                <i class="fas fa-mail-bulk"></i> {{ "BUTTON.NOTIFY-SIGN" | translate }}
              </a>
              <a class="dropdown-item cursor-hover pointer"
                 *ngIf="hasCloudSignatureOption(document) && hasAuthority('own:document:sign:10200')"
                 (click)="openModalSignInCloud(document)">
                <i class="fa fa-stamp"></i> {{ "BUTTON.SIGN-ONE-SIGN" | translate }}
              </a>
              <a class="dropdown-item cursor-hover pointer"
                 *ngIf="hasRemoteSignatureOption(document) && hasAuthority('own:document:sign:10202')"
                 (click)="openModalSignBox(document)">
                <i class="fa fa-stamp"></i> {{ "BUTTON.SIGNING-REMOTELY" | translate }}
              </a>
              <a class="dropdown-item cursor-hover pointer"
                 data-toggle="tooltip"
                 data-placement="top"
                 title="{{ 'MESSAGE.UPLOAD-IMAGES' | translate }}"
                 *ngIf="hasntDataComplete(document) && (hasAuthority('own:document:sign:10200') || hasAuthority('own:document:sign:10201'))"
                 (click)="completeDataSignCloud(document)">
                <i class="fa fa-pen"></i> {{getDescription4Action(document) | translate}}
              </a>
              <a class="dropdown-item cursor-hover pointer"
                 data-toggle="tooltip"
                 data-placement="top"
                 title="{{ 'MESSAGE.VALIDITY-MAXIMUM-LIMIT' | translate }}"
                 *ngIf="(isInvalidPersonByValidityPeriod(document))
                 && (hasAuthority('own:document:sign:10200') || hasAuthority('own:document:sign:10201'))"
                 (click)="generateRequestInSolcert(document)">
                <i class="fa fa-id-card"></i> {{ "BUTTON.VALIDATE-DOCUMENTS" | translate }}
              </a>
              <a class="dropdown-item cursor-hover pointer"
                 *ngIf="hasMultipleAttachDigitalSignatureOption(document) && hasAuthority('own:document:sign:one2one') && completedReview(document)"
                 (click)="openModalSignDigital(document) ">
                <i class="fa fa-signature"></i> {{ "BUTTON.DIGITALLY-SIGN" | translate }}
              </a>
              <a class="dropdown-item cursor-hover pointer"
                 *ngIf="hasReviewOption(document) && hasAuthority('own:document:review:one2one')
                && enabledReviewOption(document)"
                 (click)="openModalReview(document, REVIEWTYPE_ONE2ONE)">
                <i class="fa fa-eye"></i> {{ "BUTTON.REVIEW" | translate }}
              </a>
              <a class="dropdown-item cursor-hover pointer"
                 *ngIf="hasAuthority('own:resource:get:one2one:stream') && !wasCanceled(document) && !wasDeleted(document)"
                 (click)="downloadOf(document)">
                <i class="fa fa-file-download"></i> {{ "BUTTON.DOWNLOAD" | translate }}
              </a>
              <a class="dropdown-item cursor-hover pointer"
                 *ngIf="hasAcknowledgmentReceipt(document)"
                 (click)="downloadAcknowledgmentReceipt(document)">
                <i class="fa fa-file-download"></i> {{ "BUTTON.DOWNLOAD-ACKNOWLEDGE" | translate }}
              </a>
              <a class="dropdown-item cursor-hover pointer"
                 *ngIf="hasResendMailOption(document) && hasAuthority('own:mail:resend:url')"
                 (click)="resendMailSigner(document)">
                <i class="fa fa-envelope"></i> {{ "BUTTON.FORWARD-URL" | translate }}
              </a>
              <a class="dropdown-item cursor-hover pointer"
                 *ngIf="hasCopyUrlOption(document) && hasAuthority('own:document:copy:url:operator')"
                 (click)="copyToClipboard(document)">
                <i class="fa fa-copy"></i> {{ "BUTTON.COPY-URL" | translate }}
              </a>
              <a class="dropdown-item cursor-hover pointer"
                 *ngIf="hasMarkAttendOption(document) && hasAuthority('own:document:attend:one2one')"
                 (click)="openModalAttend(document)">
                <i class="fa fa-arrow-alt-circle-right"></i> {{ "BUTTON.MARK-AS-ATTENDED" | translate }}
              </a>
              <a class="dropdown-item cursor-hover pointer"
                 *ngIf="hasMarkUnattendOption(document) && hasAuthority('own:document:unattend:one2one')"
                 (click)="openModalUnattend(document)">
                <i class="fa fa-arrow-alt-circle-left"></i> {{ "BUTTON.MARK-AS-UNATTENDED" | translate }}
              </a>
              <a class="dropdown-item cursor-hover pointer"
                 *ngIf="hasViewParticipantsOption() && hasAuthority('own:person:get:document')"
                 (click)="openModalViewParticipants(document)">
                <i class="fa fa-users"></i> {{ "BUTTON.VIEW-PARTICIPANTS" | translate }}
              </a>
              <a class="dropdown-item cursor-hover pointer"
                 *ngIf="hasReassignParticipantsOption(document) && hasAuthority('own:operator:reasign')"
                 (click)="openModalBy(document,MODAL_REASIGN_PARTICIPANT)">
                <i class="fa fa-users-cog"></i> {{ "BUTTON.REASSIGN-PARTICIPANTS" | translate }}
              </a>
              <a class="dropdown-item cursor-hover pointer"
                 *ngIf="hasFinalizeDocument(document)"
                 (click)="openModalBy(document,MODAL_FINALIZE_DOCUMENT)">
                <i class="fas fa-check"></i> {{ "BUTTON.FINALIZE-DOCUMENT" | translate }}
              </a>
              <a class="dropdown-item cursor-hover pointer"
                 *ngIf="(hasCancelOption(document) || (hasAuthority('own:document:cancel:one2one')
               && !wasCanceled(document)) && !(hasRole(ROLE_LITE_ADMIN) || hasRole(ROLE_LITE_ASSISTANT)))"
                 (click)="openModalCancel(document)">
                <i class="fa fa-minus-square"></i> {{ "BUTTON.CANCEL-ANNUL" | translate }}
              </a>
              <a class="dropdown-item cursor-hover pointer"
                 *ngIf="hasAuthority('own:view:document:10205') && hasSentAttachByMailOption(document)"
                 (click)="openModalSendDocumentViaEmail(document)">
                <i class="fas fa-mail-bulk"></i> {{ "BUTTON.SEND-ATTACHMENTS-TO-EMAIL" | translate }}
              </a>
              <a class="dropdown-item cursor-hover pointer"
                 *ngIf="hasAuthority('own:view:document:10203')"
                 (click)="openModalViewDocument(document)">
                <i class="fas fa-route"></i> {{ "BUTTON.VIEW-TRACEABILITY" | translate }}
              </a>
              <a class="dropdown-item cursor-hover pointer"
                 *ngIf="hasModifyOption(document) && hasAuthority('own:document:modify:one2one')"
                 (click)="loadRequiredDataAndOpenModalModifyDocument(document)">
                <i class="fas fa-file-signature"></i> {{ "BUTTON.MODIFY" | translate }}
              </a>
              <a class="dropdown-item cursor-hover pointer"
                 *ngIf="hasRevertOption(document) && true "
                 (click)="openModalRevertDocument(document)">
                <i class="fas fa-history"></i> {{ "BUTTON.REVERT-STATUS" | translate }}
              </a>
              <a class="dropdown-item cursor-hover pointer"
                 *ngIf="(hasAuthority('own:view:document:10207'))"
                 (click)="openModalViewDetailDocument(document)">
                <i class="fas fa-route"></i> {{ "BUTTON.SHOW-DETAIL" | translate }}
              </a>
              <a class="dropdown-item cursor-hover pointer"
                 *ngIf="(hasDeleteOption(document) || (hasAuthority('own:document:delete:one2one') &&
                  isAllowedDelete(document))) || hasAuthority('own:view:document:10209')"
                 (click)="openModalDelete(document)">
                <i class="fa fa-trash-alt"></i> {{ "BUTTON.DELETE" | translate }}
              </a>
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <nav class="Page navigation pagination-custom">
    <div class="row">
      <div class="col-md-8 mt-1">
        <div class="justify-content-row">
          <span class="mr-1 font-weight-normal">Mostrar </span>
          <select class="mr-1 br-6 form-control-sm" [(ngModel)]="pageNumber"
                  (ngModelChange)="loadDocuments(enumPage.First)">
            <option *ngFor="let page of pageNumbers" [value]="page.value"
                    class="font-weight-bold">{{page.value}}</option>
          </select>
          <span class="font-weight-normal"> registros.</span>
        </div>
        <div class="page-total-entries">
          {{ "LABEL.TOTAL-RECORDS" | translate }}
          : {{documents.length + (page.number * page.size)}} {{ "LABEL.OF" | translate }} {{page.totalElements}}
        </div>
      </div>
      <div class="col-md-4">
        <ul class="pagination justify-content-end text-center">
          <li class="page-item btn-paged-ends cursor-pointer {{page.number === 0 ? 'disabled' : ''}}">
            <a class="prev {{page.number === 0 ? 'disabled' : ''}}" (click)="loadDocuments(enumPage.First)"
               tabindex="-1" aria-disabled="true">
              <i class=" fa fa-angle-double-left" aria-hidden="true"></i>
              {{ "BUTTON.FIRST" | translate }}
            </a>
          </li>
          <li class="cursor-pointer {{page.number == 0 ? 'disabled' : ''}}">
            <a class="left" (click)="loadDocuments(enumPage.Previous)">
              <i class="fa fa-angle-left" aria-hidden="true"></i></a>
          </li>
          <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
            <a class="right" (click)="loadDocuments(enumPage.Next)"><i
              class="fa fa-angle-right" aria-hidden="true"></i></a>
          </li>
          <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}"
              (click)="loadDocuments(enumPage.Last)">
            <a class="next">
              {{ "BUTTON.LAST" | translate }}
              <i class="fa fa-angle-double-right" aria-hidden="true"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>
<app-loading
  *ngIf="(loading && !calledOfAutorefresh) || loadingSign || loadingSave || loadingShowBy || loadingAttend || loadingDownload"></app-loading>
<app-copyclipboard *ngIf="loadingCopyClipboard"></app-copyclipboard>
